export interface IModalTypes<T> {
  name:string,
  body?:T
}


export class ModalTypes<T> implements IModalTypes<T> {
  name:string = null
  body?:T
}
